// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3vphZ","form":"styles_form__Kumxi"};